import React from 'react';
const immediateItems = [{
  emoji: '📘',
  text: 'I 12 volumi digitali completi (Primaria e Secondaria)'
}, {
  emoji: '📝',
  text: 'Programmazioni annuali, trimestrali e quotidiane'
}, {
  emoji: '🏃',
  text: 'Banca dati di giochi, circuiti e sport regolati'
}, {
  emoji: '📊',
  text: 'Protocolli di Test Fisici (Resistenza, Flessibilità, Forza)'
}, {
  emoji: '🗂️',
  text: "Schede di osservazione dell'alunno"
}];
export function ContentPreview() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4" data-id="element-29">
      <div className="max-w-5xl mx-auto" data-id="element-30">
        {/* Immediate Delivery */}
        <div className="text-center" data-id="element-31">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-10" data-id="element-32">
            📲 Cosa riceverai immediatamente?
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-3xl mx-auto mb-12 text-left" data-id="element-33">
            {immediateItems.map((item, i) => <div key={i} className="bg-bg-alt rounded-2xl p-6 border border-border-light flex items-center gap-4 shadow-sm" data-id="element-34">
                <span className="text-3xl flex-shrink-0" data-id="element-35">{item.emoji}</span>
                <span className="text-text-main font-bold text-base sm:text-lg leading-snug" data-id="element-36">
                  {item.text}
                </span>
              </div>)}
          </div>

          <p className="text-primary font-serif italic text-2xl sm:text-4xl font-bold" data-id="element-37">
            Copri tutto il materiale dell'anno in un istante
          </p>
        </div>
      </div>
    </section>;
}